import React from 'react';
import MoxOuline1Img from '@/assets/image/mox-outline-1.png';
import MoxOuline2Img from '@/assets/image/mox-outline-2.png';

import cx from './index.module.scss';

interface Props {
  activeIdx: number;
}

const MoxAnimation: React.FC<Props> = ({ activeIdx }) => {
  return (
    <div className={cx('mox-animation')}>
      {activeIdx === 1 && (
        <div className={cx('animation-item', 'animation-style-1')}>
          <img className={cx('img', 'img-1')} src={MoxOuline1Img} alt="" />
          <img className={cx('img', 'img-2')} src={MoxOuline1Img} alt="" />
          <img className={cx('img', 'img-3')} src={MoxOuline1Img} alt="" />
          <img className={cx('img', 'img-4')} src={MoxOuline1Img} alt="" />
          <img className={cx('img', 'img-5')} src={MoxOuline1Img} alt="" />
        </div>
      )}
      {[2, 3, 4, 5, 6, 7].includes(activeIdx) && (
        <div className={cx('animation-item', 'animation-style-2', `activeIndex${activeIdx}`)}>
          <img className={cx('img', 'img-1')} src={MoxOuline2Img} alt="" />
          <img className={cx('img', 'img-2')} src={MoxOuline2Img} alt="" />
          <img className={cx('img', 'img-3')} src={MoxOuline2Img} alt="" />
          <img className={cx('img', 'img-4')} src={MoxOuline2Img} alt="" />
          <img className={cx('img', 'img-5')} src={MoxOuline2Img} alt="" />
        </div>
      )}
    </div>
  );
};

export default MoxAnimation;
